import { render } from "./Step6.vue?vue&type=template&id=26aa362a&scoped=true"
import script from "./Step6.vue?vue&type=script&lang=js"
export * from "./Step6.vue?vue&type=script&lang=js"

import "./tailwind.css?vue&type=style&index=0&id=26aa362a&scoped=true&lang=css&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26aa362a"]])

export default __exports__